import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
export default {
  name: "cpt-dataV-decoration",
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  watch: {
    option: {
      handler: function handler() {
        this.refreshFlagKey = require('uuid').v1(); //强制刷新视图
      },
      deep: true //深度监听

    },
    width: function width() {
      this.refreshFlagKey = require('uuid').v1();
    }
  },
  data: function data() {
    return {
      refreshFlagKey: require('uuid').v1()
    };
  }
};